// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';

const RequestFormWrapper: StatelessFunctionalComponent<any> = styled.div`
  margin-bottom: 1.4rem;

  .row {
    margin: 0 -0.7rem;
  }

  .col-6 {
    padding: 0 0.7rem 0.8rem 0.7rem !important;
  }

  .col-12 {
    padding: 0 0.7rem !important;
  }

  .request-form {
    &__input-field {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
  }

  .form-input {
    &__label {
      font-size: 1.4rem;
      font-weight: normal;
      line-height: 1.8rem;
    }
  }
`;
export default RequestFormWrapper;
